import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import InventoryReportDetailItem from "../entities/inventoryReportDetailItem";
interface InventoryReportDetailState
  extends ListState<InventoryReportDetailItem> {}
class InventoryReportDetailModule extends ListModule<
  InventoryReportDetailState,
  any,
  InventoryReportDetailItem
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<InventoryReportDetailItem>(),
    loading: false,
  };
  actions = {
    async getAll(
      context: ActionContext<InventoryReportDetailState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Inventory/InventoryStatisticsDetail",
        { params: payload.data }
      );
      context.state.loading = false;
      context.state.list = reponse.data.result
        .items as InventoryReportDetailItem[];
      context.state.totalCount = reponse.data.result.totalRows;
    },
  };
  mutations = {
    setCurrentPage(state: InventoryReportDetailState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: InventoryReportDetailState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const inventoryReportDetailModule = new InventoryReportDetailModule();
export default inventoryReportDetailModule;
